export const LANG_CODES = [
  'af-ZA',
  'am-ET',
  'ar-AE',
  'ar-EG',
  'ar-SA',
  'bg-BG',
  'bn-BD',
  'bs-BA',
  'cs-CZ',
  'cy-GB',
  'da-DK',
  'de-DE',
  'el-GR',
  'en-US',
  'en-GB',
  'es-ES',
  'es-MX',
  'et-EE',
  'fi-FI',
  'fr-CA',
  'fr-FR',
  'he-IL',
  'hi-IN',
  'hr-HR',
  'ht-HT',
  'hu-HU',
  'is-IS',
  'it-IT',
  'ja-JP',
  'kl-GL',
  'km-KH',
  'ko-KR',
  'lo-LA',
  'lt-LT',
  'lv-LV',
  'mg-MG',
  'mh-MH',
  'mi-NZ',
  'mk-MK',
  'mn-MN',
  'mr-IN',
  'ms-MY',
  'my-MM',
  'ne-NP',
  'nl-BE',
  'nl-NL',
  'no-NO',
  'pl-PL',
  'pt-BR',
  'pt-PT',
  'ro-RO',
  'ru-RU',
  'si-LK',
  'sk-SK',
  'sl-SI',
  'so-SO',
  'sq-AL',
  'sr-RS',
  'sv-SE',
  'sw-TZ',
  'ta-IN',
  'th-TH',
  'tl-PH',
  'tr-TR',
  'uk-UA',
  'ur-PK',
  'vi-VN',
  'zh-CN',
  'zh-HK',
  'zu-ZA',
] as const;

export const LOCALE_START_WEEK: Record<string, 0 | 2 | 1 | 3 | 4 | 5 | 6> = {
  AF: 6,
  AX: 1,
  AL: 1,
  DZ: 6,
  AS: 0,
  AD: 1,
  AO: 1,
  AI: 1,
  AQ: 1,
  AG: 0,
  AR: 1,
  AM: 1,
  AW: 1,
  AC: 1,
  AU: 1,
  AT: 1,
  AZ: 1,
  BS: 0,
  BH: 6,
  BD: 0,
  BB: 1,
  BY: 1,
  BE: 1,
  BZ: 0,
  BJ: 1,
  BM: 1,
  BT: 0,
  BO: 1,
  BA: 1,
  BW: 0,
  BV: 1,
  BR: 0,
  IO: 1,
  VG: 1,
  BN: 1,
  BG: 1,
  BF: 1,
  BI: 1,
  KH: 0,
  CM: 1,
  CA: 0,
  IC: 1,
  CV: 1,
  BQ: 1,
  KY: 1,
  CF: 1,
  EA: 1,
  TD: 1,
  CL: 1,
  CN: 1,
  CX: 1,
  CP: 1,
  CC: 1,
  CO: 0,
  KM: 1,
  CG: 1,
  CD: 1,
  CK: 1,
  CR: 1,
  CI: 1,
  HR: 1,
  CU: 1,
  CW: 1,
  CY: 1,
  CZ: 1,
  DK: 1,
  DG: 1,
  DJ: 6,
  DM: 0,
  DO: 0,
  EC: 1,
  EG: 6,
  SV: 0,
  GQ: 1,
  ER: 1,
  EE: 1,
  SZ: 1,
  ET: 0,
  FK: 1,
  FO: 1,
  FJ: 1,
  FI: 1,
  FR: 1,
  GF: 1,
  PF: 1,
  TF: 1,
  GA: 1,
  GM: 1,
  GE: 1,
  DE: 1,
  GH: 1,
  GI: 1,
  GR: 1,
  GL: 1,
  GD: 1,
  GP: 1,
  GU: 0,
  GT: 0,
  GG: 1,
  GN: 1,
  GW: 1,
  GY: 1,
  HT: 1,
  HM: 1,
  HN: 0,
  HK: 0,
  HU: 1,
  IS: 1,
  IN: 0,
  ID: 0,
  IR: 6,
  IQ: 6,
  IE: 1,
  IM: 1,
  IL: 0,
  IT: 1,
  JM: 0,
  JP: 0,
  JE: 1,
  JO: 6,
  KZ: 1,
  KE: 0,
  KI: 1,
  XK: 1,
  KW: 6,
  KG: 1,
  LA: 0,
  LV: 1,
  LB: 1,
  LS: 1,
  LR: 1,
  LY: 6,
  LI: 1,
  LT: 1,
  LU: 1,
  MO: 0,
  MG: 1,
  MW: 1,
  MY: 1,
  MV: 5,
  ML: 1,
  MT: 0,
  MH: 0,
  MQ: 1,
  MR: 1,
  MU: 1,
  YT: 1,
  MX: 0,
  FM: 1,
  MD: 1,
  MC: 1,
  MN: 1,
  ME: 1,
  MS: 1,
  MA: 1,
  MZ: 0,
  MM: 0,
  NA: 1,
  NR: 1,
  NP: 0,
  NL: 1,
  NC: 1,
  NZ: 1,
  NI: 0,
  NE: 1,
  NG: 1,
  NU: 1,
  NF: 1,
  KP: 1,
  MK: 1,
  MP: 1,
  NO: 1,
  OM: 6,
  PK: 0,
  PW: 1,
  PS: 1,
  PA: 0,
  PG: 1,
  PY: 0,
  PE: 0,
  PH: 0,
  PN: 1,
  PL: 1,
  PT: 0,
  PR: 0,
  QA: 6,
  RE: 1,
  RO: 1,
  RU: 1,
  RW: 1,
  WS: 0,
  SM: 1,
  ST: 1,
  CQ: 1,
  SA: 0,
  SN: 1,
  RS: 1,
  SC: 1,
  SL: 1,
  SG: 0,
  SX: 1,
  SK: 1,
  SI: 1,
  SB: 1,
  SO: 1,
  ZA: 0,
  GS: 1,
  KR: 0,
  SS: 1,
  ES: 1,
  LK: 1,
  BL: 1,
  SH: 1,
  KN: 1,
  LC: 1,
  MF: 1,
  PM: 1,
  VC: 1,
  SD: 6,
  SR: 1,
  SJ: 1,
  SE: 1,
  CH: 1,
  SY: 6,
  TW: 0,
  TJ: 1,
  TZ: 1,
  TH: 0,
  TL: 1,
  TG: 1,
  TK: 1,
  TO: 1,
  TT: 0,
  TA: 1,
  TN: 1,
  TR: 1,
  TM: 1,
  TC: 1,
  TV: 1,
  UM: 0,
  VI: 0,
  UG: 1,
  UA: 1,
  AE: 6,
  /*   GB: [1, 0], */
  GB: 1,
  US: 0,
  UY: 1,
  UZ: 1,
  VU: 1,
  VA: 1,
  VE: 0,
  VN: 1,
  WF: 1,
  EH: 1,
  YE: 0,
  ZM: 1,
  ZW: 0,
};
export const RTL_LOCALES = ['ar-AE', 'ar-EG', 'ar-SA', 'he-IL', 'ur-PK'];
